import React from 'react';
import { Link } from 'react-router-dom';
import Header from '@/components/layout/Header';
import Footer from '@/components/layout/Footer';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/contexts/AuthContext';
import { Clock, Mail } from 'lucide-react';

export default function PendingApprovalPage() {
  const { user } = useAuth();
  return (
    <div className="min-h-screen flex flex-col bg-[#F7F9FC]" data-testid="pending-approval-page">
      <Header />
      <main className="flex-1 max-w-xl w-full mx-auto px-4 py-16">
        <div className="bg-white rounded-2xl border border-slate-200 p-10 text-center">
          <div className="w-14 h-14 rounded-full bg-amber-50 flex items-center justify-center mx-auto"><Clock className="h-7 w-7 text-amber-600" /></div>
          <h1 className="text-2xl font-bold text-[#2a3e5d] mt-5">Thanks — your organisation account is being reviewed</h1>
          <p className="text-slate-600 mt-3 text-sm leading-relaxed">
            We check every new organisation to keep the platform secure for your staff. This usually takes less than one working day.
            {user?.email && <> We'll email <strong>{user.email}</strong> as soon as you're approved.</>}
          </p>
          <p className="text-slate-500 mt-4 text-xs flex items-center justify-center gap-1.5"><Mail className="h-3.5 w-3.5" />Questions? Email admin@commonimpactelearning.co.uk</p>
          <div className="mt-7 flex flex-wrap justify-center gap-3">
            <Button asChild className="bg-[#20acf6] hover:bg-[#3bb8f7]"><Link to="/courses" data-testid="pending-browse-courses">Browse courses</Link></Button>
            <Button asChild variant="outline"><Link to="/pricing" data-testid="pending-view-pricing">View pricing</Link></Button>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
